import { useCallback, useState } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import { useStyles, Drawer } from "./styles";

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItemIcon from '@mui/material/ListItemIcon';
import ProjectIcon from "../../../assets/header/projects.svg";
import EstudioIcon from "../../../assets/header/studio.svg"; 
//import ChatIcon from "../../../assets/header/chat.svg";
import ModeloProntoIcon from "../../../assets/header/modelosProntos.svg";
//import CampanhasIcon from "../../../assets/header/campanhas.svg";
import MyAccountIcon from "../../../assets/header/account.svg";
import WhatsAppIcon from "../../../assets/header/whatsapp.svg";
import SociaisIcon from "../../../assets/header/socialAccount.svg";
import RadioIcon from "../../../assets/header/radio.svg";
import AulasIcon from "../../../assets/header/aulas.svg";
import VisaoGeral from "../../../assets/header/visaoGeral.svg";
import TreinamentoIcon from "../../../assets/header/treinamento.svg";
//import SuportIcon from "../../../assets/header/support.svg";
import FinanceiroIcon from "../../../assets/header/financeiro.svg";
import { RedirectOptions } from '../Right';
import { isLocalhost } from '../../../utils/constants';
import { isReleaseEnvironment } from '../../../utils/constants';


export default function SideBarMenu() {
  //const theme = useTheme();
  const [open, setOpen] = useState(true);
  const [direction, setDirection] = useState(false);
  const { token } = useAuth();
  const navigate = useNavigate();
  const styles = useStyles();

  const handleGoToDsV3 = useCallback(
    (option: RedirectOptions) => {
      const alias = isLocalhost 
      ? "https://tech.datasales.info"
      : isReleaseEnvironment 
        ? "https://qa.datasales.info"
        : "https://app.dsmarketing.com.br";
      const urlDsV2 = ` ${alias}/sign-as-user/${token}?shortToRedirect=${option}`;
      window.location.assign(urlDsV2);
    },
    [token]
  );

  const MENU = [
    [
      {
        title: 'Visão Geral',
        onClick: () => navigate("/dashboard"),
        icon: VisaoGeral,
      }
    ],
    [
      {
        title: 'Meus Projetos',
        onClick: () => handleGoToDsV3(`projects`),
        icon: ProjectIcon,
      },
      {
        title: 'Estudio de Criação',
        icon: EstudioIcon,
        onClick: () => handleGoToDsV3(`newStudio`),
      },
      {
        title: 'Artes Prontas',
        icon: ModeloProntoIcon,
        onClick: () => handleGoToDsV3(`professional`),
      }
    ],
    [
      {
        title: 'Minha conta',
        onClick: () => navigate("/account-settings"),
        icon: MyAccountIcon,
      },
      {
        title: 'WhatsApp',
        onClick: () => navigate("/whatsapp"),
        icon: WhatsAppIcon,
      },
      {
        title: 'Redes Sociais',
        onClick: () => handleGoToDsV3(`redes_sociais`),
        icon: SociaisIcon,
      },
      {
        title: 'Rádios',
        onClick: () => handleGoToDsV3(`radios`),
        icon: RadioIcon,
      }
    ],
    [
      {
        title: 'Vídeo aulas',
        onClick: () => window.open("https://www.youtube.com/playlist?list=PLr7dYaCP_s-xDLMHwir93qh1USr9Mdfyx"),
        icon: AulasIcon,
      },
      {
        title: 'Treinamento',
        onClick: () => window.open("https://calendly.com/datasales"),
        icon: TreinamentoIcon,
      },
      /*{
        title: 'Atendimento',
        onClick: () => console.log('atendimento'),
        icon: SuportIcon,
      },*/
      {
        title: 'Financeiro',
        onClick: () => handleGoToDsV3(`financial`),
        icon: FinanceiroIcon,
      },
    ]
  ];

  return (
    <Box className={styles.sidebar}>
      <Drawer variant="permanent" open={open}>   
        <List disablePadding dense sx={{px: 2,}}>
          <ListItemButton
            onClick={() => {
              setOpen(!open);
              setDirection(!direction);
            }}
            sx={{ 
              p: 2, 
              borderRadius: "4px",  
              color: "#778799", 
              justifyContent: open ? 'initial' : 'center',
              '&:hover':{
                background: '#F3F4FB',
                color: '#0C20B5',
                '& .MuiTypography-root':{
                  color: '#0C20B5'
                }
              } 
            }}
          >
            <Stack 
              spacing={1} 
              direction="row" 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
              }}
            >
                {open ? 
                  <> 
                    <ChevronLeftIcon /> 
                      <Typography 
                        sx={{ 
                          color: '#778799',
                          fontSize: '0.75rem',
                          fontWeight: 400,
                          lineHeight: '1rem',
                          letterSpacing: 0
                        }}
                      >
                        Fechar Menu
                      </Typography>
                  </> : 
                  <ChevronRightIcon /> }
            </Stack>
          </ListItemButton>
        </List> 

        {MENU.map((menu, indexArrayMaster) => (
          <>
            <List
              sx={{
                justifyContent: open ? 'initial' : 'center',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.25rem',
                px: 2,
              }}
            >
              {menu.map((menu) => (
                <ListItem title={`${menu.title}`} disablePadding 
                  sx={{ 
                    display: 'block', 
                    ...(!open &&{ px: 0 })
                  }}>
                  <ListItemButton
                    title={`${menu.title}`}
                    sx={{
                      height: '2.4rem',
                      justifyContent: open ? 'initial' : 'center',
                      py: 1.5,
                      '&:hover':{
                        color: '#0C20B5',
                        background: '#F3F4FB',
                        '& .MuiListItemText-primary':{
                          color: '#0C20B5'
                        }
                      }
                    }}
                    onClick={menu.onClick}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 2 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      <img src={menu.icon} alt="logout" />
                    </ListItemIcon>
                    <ListItemText 
                      primary={`${menu.title}`}
                      sx={{ 
                        opacity: open ? 1 : 0, 
                        '& .MuiListItemText-primary':{
                          fontSize: '0.75rem',
                          fontWeight: 500,
                          letterSpacing: '0.02px',
                          lineHeight: '1.25rem',
                          color: '#374957'
                        }
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
              {(MENU.length !== indexArrayMaster + 1) &&  <Divider />}
            </List>   
          </>
        ))}
      </Drawer>
    </Box>
  );
}